import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import AdminGateway from '~apis/admin';

import combinedActions from '~redux/combinedActions';
import { GatewayResponseStatus } from '~types/gateway';

import { SagaWatcherReturnType } from '~types/saga';
import { ErrorMessages } from '~utils/constants';
import { ModuleEnum, PermissionsEnum } from '~utils/enums';

import UtilFunctions from '~utils/functions';
import navActions from '~utils/navActions';

export default function* watchStartup(): SagaWatcherReturnType {
    yield takeEvery(
        'auth/authStartupAttempt',
        handleStartup,
    );
};


function* handleStartup() {
    const authToken = UtilFunctions.Auth.getAuthToken();

    if (authToken) {
        yield put(combinedActions.authLogoutAttempt());
        return;
    }

    yield call(() => UtilFunctions.Auth.clearAuthToken());

    yield call(() => UtilFunctions.SessionStorage.removeItem('authTokenExp'));

    yield put(combinedActions.authStartupFailure());

    yield call(navActions.navResetToLogin);
}
